// import React, { Fragment, useState, useEffect, useRef } from "react";
// import { Container, Row, Col, Modal } from "react-bootstrap";
// import Form from "react-bootstrap/Form";
// import ReCAPTCHA from "react-google-recaptcha";

// import * as apiUrl from "../../apiUrl";

// const CareerInnerDescription = ({ title, description }) => {
//   const [setCareerInnerDescription] = useState([]);

//   const [setcareerscaptchaToken] = useState(null);
//   const [formData, setFormData] = useState({
//     firstName: "",
//     lastName: "",
//     email: "",
//     mobile: "",
//     message: "",
//     position: "",
//     cv: null,
//   });
//   const [errors, setErrors] = useState({});
//   const [showModal, setShowModal] = useState(false);

//   const captchaRef = useRef(null);

//   // useEffect(() => {
//   //   const fetchCareerInnerDescription = async () => {
//   //     try {
//   //       const response = await fetch(
//   //         apiUrl.apiUrl + `/api/careers/inner-form-section`
//   //       );
//   //       if (!response.ok) {
//   //         throw new Error("Failed to fetch data");
//   //       }
//   //       const data = await response.json();
//   //       setCareerInnerDescription(data);
//   //     } catch (error) {
//   //       console.error("Error fetching data:", error);
//   //     }
//   //   };

//   //   fetchCareerInnerDescription();
//   // }, []);

//   const validateField = (fieldName, value) => {
//     const namePattern = /^[A-Za-z\s]+$/;
//     const mobilePattern = /^[0-9]+$/;
//     const allowedFileTypes = [
//       "application/pdf",
//       "application/msword",
//       "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
//     ];
//     let error = "";

//     switch (fieldName) {
//       case "firstName":
//         if (!value) error = "Please enter your First Name.";
//         else if (!namePattern.test(value))
//           error = "First Name should only contain letters.";
//         break;

//       case "lastName":
//         if (!value) error = "Please enter your Last Name.";
//         else if (!namePattern.test(value))
//           error = "Last Name should only contain letters.";
//         break;

//       case "email":
//         if (!value) error = "Please enter your Email.";
//         else if (!/\S+@\S+\.\S+/.test(value)) error = "Email is invalid.";
//         break;

//       case "mobile":
//         if (!value) error = "Please enter your Mobile Number.";
//         else if (!mobilePattern.test(value) || value.length < 10)
//           error =
//             "Mobile Number should only contain numbers and be at least 10 digits.";
//         break;

//       case "message":
//         if (!value) error = "Please enter a Message.";
//         break;

//       case "position":
//         if (!value) error = "Please select a position.";
//         break;

//       // case "cv":
//       //   if (!value) {
//       //     error = "Please upload a CV.";
//       //   } else if (
//       //     typeof value === "object" &&
//       //     !allowedFileTypes.includes(value.type)
//       //   ) {
//       //     error = "Only PDF and DOC/DOCX files are allowed.";
//       //   }
//       //   break;

//       // case "cv":
//       //   if (!value) {
//       //     error = "Please upload a CV.";
//       //   } else if (typeof value === "object") {
//       //     const maxSizeKB = 1000;

//       //     if (!allowedFileTypes.includes(value.type)) {
//       //       error = "Only PDF and DOC/DOCX files are allowed.";
//       //     } else if (value.size > maxSizeKB * 1024) {
//       //       error = "CV must be less than 1000 KB (1 MB).";
//       //     }
//       //   }
//       //   break;

//       case "cv":
//         if (!value) {
//           error = "Please upload a CV.";
//         } else if (typeof value === "object") {
//           const maxSizeKB = 1000;

//           if (value.type !== "application/pdf") {
//             error = "Only PDF files are allowed.";
//           } else if (value.size > maxSizeKB * 1024) {
//             error = "CV must be less than 1000 KB (1 MB).";
//           }
//         }
//         break;

//       case "careerscaptchaToken":
//         if (!value) error = "Please Select the CAPTCHA.";
//         break;

//       default:
//         break;
//     }

//     setErrors((prevErrors) => ({ ...prevErrors, [fieldName]: error }));
//   };

//   const handleBlur = (e) => {
//     const { name, value, files } = e.target;
//     validateField(name, name === "cv" ? files[0] : value);
//   };

//   const handleNameChange = (e) => {
//     const { name, value } = e.target;
//     const namePattern = /^[A-Za-z\s]*$/;

//     if (namePattern.test(value)) {
//       setFormData((prev) => ({ ...prev, [name]: value }));
//     }
//   };

//   const handleMobileChange = (e) => {
//     const { value } = e.target;
//     const mobilePattern = /^[0-9]*$/;

//     if (mobilePattern.test(value)) {
//       setFormData((prev) => ({ ...prev, mobile: value }));
//     }
//   };

//   // const handleFileChange = (e) => {
//   //   const input = e.target;
//   //   const cv = input.files[0];
//   //   let error = "";

//   //   if (cv) {
//   //     const allowedTypes = [
//   //       "application/pdf",
//   //       "application/msword",
//   //       "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
//   //     ];
//   //     if (!allowedTypes.includes(cv.type)) {
//   //       error = "Only PDF and DOC/DOCX files are allowed.";
//   //       setFormData((prev) => ({ ...prev, cv: null }));
//   //       input.value = "";
//   //     } else {
//   //       setFormData((prev) => ({ ...prev, cv }));
//   //     }
//   //   } else {
//   //     error = "Please upload a file.";
//   //     setFormData((prev) => ({ ...prev, cv: null }));
//   //   }

//   //   setErrors((prevErrors) => ({ ...prevErrors, cv: error }));
//   // };

//   // const handleFileChange = (e) => {
//   //   const input = e.target;
//   //   const cv = input.files[0];
//   //   let error = "";

//   //   const maxSizeKB = 1000;

//   //   if (cv) {
//   //     const allowedTypes = [
//   //       "application/pdf",
//   //       "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
//   //     ];

//   //     if (!allowedTypes.includes(cv.type)) {
//   //       error = "Only PDF and DOC/DOCX files are allowed.";
//   //       input.value = "";
//   //       setFormData((prev) => ({ ...prev, cv: null }));
//   //     } else if (cv.size > maxSizeKB * 1024) {
//   //       error = "CV must be less than 1000 KB (1 MB).";
//   //       input.value = "";
//   //       setFormData((prev) => ({ ...prev, cv: null }));
//   //     } else {
//   //       setFormData((prev) => ({ ...prev, cv }));
//   //     }
//   //   } else {
//   //     error = "Please upload a file.";
//   //     setFormData((prev) => ({ ...prev, cv: null }));
//   //   }

//   //   setErrors((prevErrors) => ({ ...prevErrors, cv: error }));
//   // };

//   const handleFileChange = (e) => {
//     const input = e.target;
//     const cv = input.files[0];
//     let error = "";

//     const maxSizeKB = 1000;

//     if (cv) {
//       const allowedTypes = ["application/pdf"];

//       if (!allowedTypes.includes(cv.type)) {
//         error = "Only PDF files are allowed.";
//         input.value = "";
//         setFormData((prev) => ({ ...prev, cv: null }));
//       } else if (cv.size > maxSizeKB * 1024) {
//         error = "CV must be less than 1000 KB (1 MB).";
//         input.value = "";
//         setFormData((prev) => ({ ...prev, cv: null }));
//       } else {
//         setFormData((prev) => ({ ...prev, cv }));
//       }
//     } else {
//       error = "Please upload a file.";
//       setFormData((prev) => ({ ...prev, cv: null }));
//     }

//     setErrors((prevErrors) => ({ ...prevErrors, cv: error }));
//   };

//   const handlePositionChange = (e) => {
//     const { value } = e.target;
//     setFormData((prev) => ({ ...prev, position: value }));
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     // Validate all fields
//     let isValid = true;
//     Object.keys(formData).forEach((key) => {
//       validateField(key, formData[key]);
//       if (errors[key]) {
//         isValid = false;
//       }
//     });

//     // Validate reCAPTCHA last
//     if (!formData.careerscaptchaToken) {
//       setErrors((prev) => ({
//         ...prev,
//         careerscaptchaToken: "Please Select the CAPTCHA.",
//       }));
//       isValid = false;
//     }

//     if (!isValid) return;

//     try {
//       const formDataObj = new FormData();

//       // console.log(formDataObj);

//       formDataObj.append("firstName", formData.firstName);
//       formDataObj.append("lastName", formData.lastName);
//       formDataObj.append("email", formData.email);
//       formDataObj.append("mobile", formData.mobile);
//       formDataObj.append("message", formData.message);
//       formDataObj.append("position", formData.position);
//       formDataObj.append("cv", formData.cv);
//       formDataObj.append("captchaToken", formData.careerscaptchaToken);

//       const response = await fetch(apiUrl.apiUrl + `/api/career/submit`, {
//         method: "POST",
//         body: formDataObj,
//         headers: {
//           Accept: "application/json",
//         },
//       });

//       const result = await response.json();

//       // console.log(result);

//       if (result.success) {
//         setShowModal(true);
//         setFormData({
//           firstName: "",
//           lastName: "",
//           email: "",
//           mobile: "",
//           message: "",
//           position: "",
//           cv: null,
//           careerscaptchaToken: "",
//         });

//         if (document.getElementById("cvInput")) {
//           document.getElementById("cvInput").value = "";
//         }

//         // Reset CAPTCHA
//         if (captchaRef.current) {
//           captchaRef.current.reset();
//         }

//         setcareerscaptchaToken(null);
//         localStorage.removeItem("careerscaptchaToken");
//       }
//     } catch (error) {
//       console.error("Error submitting form:", error);
//     }
//   };

//   const handleChange = (e) =>
//     setFormData({ ...formData, [e.target.name]: e.target.value });

//   const handleCloseModal = () => setShowModal(false);

//   return (
//     <Fragment>
//       <section className="career-inner-desc-sec">
//         <Container fluid className="career-inner-dec-container1">
//           <Row className="flex-center career-inner-desc-row1">
//             <Col md={12} className="padding-zero">
//               <div
//                 className="career-inner-content-div"
//                 dangerouslySetInnerHTML={{ __html: description }}
//               />
//             </Col>
//           </Row>
//         </Container>
//         <Container fluid>
//           <Row className="flex-center career-inner-desc-row">
//             <Col md={8} className="padding-zero">
//               <div
//                 className="career-inner-form-div light-grey-bg"
//                 data-aos="fade-up"
//               >
//                 <Form onSubmit={handleSubmit}>
//                   <Row>
//                     <Form.Group
//                       className="col-md-6 mb-3"
//                       controlId="exampleForm.ControlInput1"
//                     >
//                       <Form.Control
//                         type="text"
//                         name="firstName"
//                         placeholder="First Name"
//                         value={formData.firstName}
//                         onChange={handleNameChange}
//                         onBlur={handleBlur}
//                       />
//                       {errors.firstName && (
//                         <p className="error">{errors.firstName}</p>
//                       )}
//                     </Form.Group>
//                     <Form.Group
//                       className="col-md-6 mb-3"
//                       controlId="exampleForm.ControlInput2"
//                     >
//                       <Form.Control
//                         type="text"
//                         name="lastName"
//                         placeholder="Last Name"
//                         value={formData.lastName}
//                         onChange={handleNameChange}
//                         onBlur={handleBlur}
//                       />
//                       {errors.lastName && (
//                         <p className="error">{errors.lastName}</p>
//                       )}
//                     </Form.Group>
//                   </Row>
//                   <Row>
//                     <Form.Group
//                       className="col-md-6 mb-3"
//                       controlId="exampleForm.ControlInput3"
//                     >
//                       <Form.Control
//                         type="text"
//                         name="email"
//                         placeholder="Email"
//                         value={formData.email}
//                         onChange={handleChange}
//                         onBlur={handleBlur}
//                       />
//                       {errors.email && <p className="error">{errors.email}</p>}
//                     </Form.Group>
//                     <Form.Group
//                       className="col-md-6 mb-3"
//                       controlId="exampleForm.ControlInput4"
//                     >
//                       <Form.Control
//                         type="text"
//                         name="mobile"
//                         placeholder="Mobile Number"
//                         value={formData.mobile}
//                         onChange={handleMobileChange}
//                         onBlur={handleBlur}
//                       />
//                       {errors.mobile && (
//                         <p className="error">{errors.mobile}</p>
//                       )}
//                     </Form.Group>
//                   </Row>
//                   <Row>
//                     <Col md={12}>
//                       <Form.Group>
//                         <Form.Select
//                           className="mb-3 form-control"
//                           name="position"
//                           value={formData.position}
//                           onChange={handlePositionChange}
//                           onBlur={handleBlur}
//                         >
//                           <option value="">Choose Position</option>
//                           <option value={title}>{title}</option>
//                         </Form.Select>
//                         {errors.position && (
//                           <p className="error">{errors.position}</p>
//                         )}
//                       </Form.Group>
//                     </Col>
//                   </Row>
//                   <Row>
//                     <Form.Group
//                       className="col-md-12 mb-3"
//                       controlId="exampleForm.ControlTextarea1"
//                     >
//                       <Form.Control
//                         as="textarea"
//                         placeholder="Drop Your Message"
//                         name="message"
//                         value={formData.message}
//                         onChange={handleChange}
//                         onBlur={handleBlur}
//                         rows={3}
//                       />
//                       {errors.message && (
//                         <p className="error">{errors.message}</p>
//                       )}
//                     </Form.Group>
//                   </Row>
//                   <Row>
//                     <Form.Group htmlFor="cvInput" className="col-md-12 mb-3">
//                       <Form.Control
//                         type="file"
//                         name="cv"
//                         className="choosefile"
//                         onChange={handleFileChange}
//                         id="cvInput"
//                         // onBlur={handleBlur}
//                         onBlur={(e) => validateField("cv", e.target.files[0])}
//                         accept=".pdf,application/pdf"
//                       />
//                       {errors.cv && <p className="error">{errors.cv}</p>}
//                     </Form.Group>
//                   </Row>
//                   <Row>
//                     <Form.Group className="col-md-12 mb-3">
//                       <ReCAPTCHA
//                         className="gcaptcha-size"
//                         sitekey="6LeGM28qAAAAAGmZjltF8c4tuHV9F9vxFdjtKPoC"
//                         ref={captchaRef}
//                         onChange={(value) => {
//                           setFormData((prevData) => ({
//                             ...prevData,
//                             careerscaptchaToken: value,
//                           }));
//                           validateField("careerscaptchaToken", value);
//                         }}
//                       />
//                       {errors.careerscaptchaToken && (
//                         <p className="error gcaptcha-error-msg">
//                           {errors.careerscaptchaToken}
//                         </p>
//                       )}
//                     </Form.Group>
//                   </Row>

//                   <Row className="mt-2 form-btn">
//                     <Col md={12}>
//                       <button type="submit" className="marquis-grey-button">
//                         Submit
//                       </button>
//                     </Col>
//                   </Row>
//                 </Form>
//               </div>
//             </Col>
//           </Row>
//         </Container>
//       </section>

//       {/* Modal Component */}
//       <Modal
//         show={showModal}
//         onHide={handleCloseModal}
//         className="response-popup"
//       >
//         <Modal.Header>
//           <Modal.Title>Thank You!</Modal.Title>
//         </Modal.Header>
//         <Modal.Body>Form Submitted Successfully!</Modal.Body>
//         <Modal.Footer>
//           <button className="marquis-grey-button" onClick={handleCloseModal}>
//             Close
//           </button>
//         </Modal.Footer>
//       </Modal>
//     </Fragment>
//   );
// };

// export default CareerInnerDescription;


import React, { Fragment, useState, useEffect, useRef } from "react";
import { Container, Row, Col, Modal } from "react-bootstrap";
import Form from "react-bootstrap/Form";
import ReCAPTCHA from "react-google-recaptcha";

import * as apiUrl from "../../apiUrl";

import useCountryCode from "../../hooks/useCountryCode";
import CountryCodeField from "../common/CountryCodeField";

const CareerInnerDescription = ({ title, description }) => {
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    mobile: "",
    countryCode: "+XX",
    message: "",
    position: "",
    cv: null,
  });
  const [errors, setErrors] = useState({});
  const [showModal, setShowModal] = useState(false);

  const captchaRef = useRef(null);

  // Same auto-detect pattern as CollectionInnerAbout: auto-fills the dial
  // code when geolocation permission is granted; if denied, falls back to
  // a required dropdown instead (see CountryCodeField).
  const { countryCode, setCountryCode, permissionGranted, locationError } =
    useCountryCode();

  useEffect(() => {
    setFormData((prev) => ({ ...prev, countryCode }));
  }, [countryCode]);

  useEffect(() => {
    if (locationError) {
      setErrors((prev) => ({ ...prev, location: locationError }));
    }
  }, [locationError]);

  const validateField = (fieldName, value) => {
    const namePattern = /^[A-Za-z\s]+$/;
    const mobilePattern = /^[0-9]+$/;

    let error = "";

    switch (fieldName) {
      case "firstName":
        if (!value) error = "Please enter your First Name.";
        else if (!namePattern.test(value))
          error = "First Name should only contain letters.";
        break;

      case "lastName":
        if (!value) error = "Please enter your Last Name.";
        else if (!namePattern.test(value))
          error = "Last Name should only contain letters.";
        break;

      case "email":
        if (!value) error = "Please enter your Email.";
        else if (!/\S+@\S+\.\S+/.test(value)) error = "Email is invalid.";
        break;

      case "mobile":
        if (!value) error = "Please enter your Mobile Number.";
        else if (!mobilePattern.test(value) || value.length < 10)
          error =
            "Mobile Number should only contain numbers and be at least 10 digits.";
        break;

      case "countryCode":
        if (!value) error = "Please Select Contry Code";
        break;

      case "message":
        if (!value) error = "Please enter a Message.";
        break;

      case "position":
        if (!value) error = "Please select a position.";
        break;

      case "cv":
        if (!value) {
          error = "Please upload a CV.";
        } else if (typeof value === "object") {
          const maxSizeKB = 1000;

          if (value.type !== "application/pdf") {
            error = "Only PDF files are allowed.";
          } else if (value.size > maxSizeKB * 1024) {
            error = "CV must be less than 1000 KB (1 MB).";
          }
        }
        break;

      case "careerscaptchaToken":
        if (!value) error = "Please Select the CAPTCHA.";
        break;

      default:
        break;
    }

    setErrors((prevErrors) => ({ ...prevErrors, [fieldName]: error }));
  };

  const handleBlur = (e) => {
    const { name, value, files } = e.target;
    validateField(name, name === "cv" ? files[0] : value);
  };

  const handleNameChange = (e) => {
    const { name, value } = e.target;
    const namePattern = /^[A-Za-z\s]*$/;

    if (namePattern.test(value)) {
      setFormData((prev) => ({ ...prev, [name]: value }));
    }
  };

  const handleMobileChange = (e) => {
    const { value } = e.target;
    const mobilePattern = /^[0-9]*$/;

    if (mobilePattern.test(value)) {
      setFormData((prev) => ({ ...prev, mobile: value }));
    }
  };

  const handleCountryCodeSelect = (e) => {
    setCountryCode(e.target.value);
    validateField("countryCode", e.target.value);
  };

  const handleFileChange = (e) => {
    const input = e.target;
    const cv = input.files[0];
    let error = "";

    const maxSizeKB = 1000;

    if (cv) {
      const allowedTypes = ["application/pdf"];

      if (!allowedTypes.includes(cv.type)) {
        error = "Only PDF files are allowed.";
        input.value = "";
        setFormData((prev) => ({ ...prev, cv: null }));
      } else if (cv.size > maxSizeKB * 1024) {
        error = "CV must be less than 1000 KB (1 MB).";
        input.value = "";
        setFormData((prev) => ({ ...prev, cv: null }));
      } else {
        setFormData((prev) => ({ ...prev, cv }));
      }
    } else {
      error = "Please upload a file.";
      setFormData((prev) => ({ ...prev, cv: null }));
    }

    setErrors((prevErrors) => ({ ...prevErrors, cv: error }));
  };

  const handlePositionChange = (e) => {
    const { value } = e.target;
    setFormData((prev) => ({ ...prev, position: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validate all fields
    let isValid = true;
    Object.keys(formData).forEach((key) => {
      validateField(key, formData[key]);
      if (errors[key]) {
        isValid = false;
      }
    });

    // Validate reCAPTCHA last
    if (!formData.careerscaptchaToken) {
      setErrors((prev) => ({
        ...prev,
        careerscaptchaToken: "Please Select the CAPTCHA.",
      }));
      isValid = false;
    }

    if (!isValid) return;

    try {
      const formDataObj = new FormData();

      formDataObj.append("firstName", formData.firstName);
      formDataObj.append("lastName", formData.lastName);
      formDataObj.append("email", formData.email);
      formDataObj.append("countryCode", formData.countryCode);
      formDataObj.append("mobile", formData.countryCode + formData.mobile);
      formDataObj.append("message", formData.message);
      formDataObj.append("position", formData.position);
      formDataObj.append("cv", formData.cv);
      formDataObj.append("captchaToken", formData.careerscaptchaToken);

      const response = await fetch(apiUrl.apiUrl + `/api/career/submit`, {
        method: "POST",
        body: formDataObj,
        headers: {
          Accept: "application/json",
        },
      });

      const result = await response.json();

      if (result.success) {
        setShowModal(true);
        setFormData({
          firstName: "",
          lastName: "",
          email: "",
          mobile: "",
          countryCode,
          message: "",
          position: "",
          cv: null,
          careerscaptchaToken: "",
        });

        if (document.getElementById("cvInput")) {
          document.getElementById("cvInput").value = "";
        }

        // Reset CAPTCHA
        if (captchaRef.current) {
          captchaRef.current.reset();
        }

        localStorage.removeItem("careerscaptchaToken");
      }
    } catch (error) {
      console.error("Error submitting form:", error);
    }
  };

  const handleChange = (e) =>
    setFormData({ ...formData, [e.target.name]: e.target.value });

  const handleCloseModal = () => setShowModal(false);

  return (
    <Fragment>
      <section className="career-inner-desc-sec">
        <Container fluid className="career-inner-dec-container1">
          <Row className="flex-center career-inner-desc-row1">
            <Col md={12} className="padding-zero">
              <div
                className="career-inner-content-div"
                dangerouslySetInnerHTML={{ __html: description }}
              />
            </Col>
          </Row>
        </Container>
        <Container fluid>
          <Row className="flex-center career-inner-desc-row">
            <Col md={8} className="padding-zero">
              <div
                className="career-inner-form-div light-grey-bg"
                data-aos="fade-up"
              >
                <Form onSubmit={handleSubmit}>
                  <Row>
                    <Form.Group
                      className="col-md-6 mb-3"
                      controlId="exampleForm.ControlInput1"
                    >
                      <Form.Control
                        type="text"
                        name="firstName"
                        placeholder="First Name"
                        value={formData.firstName}
                        onChange={handleNameChange}
                        onBlur={handleBlur}
                      />
                      {errors.firstName && (
                        <p className="error">{errors.firstName}</p>
                      )}
                    </Form.Group>
                    <Form.Group
                      className="col-md-6 mb-3"
                      controlId="exampleForm.ControlInput2"
                    >
                      <Form.Control
                        type="text"
                        name="lastName"
                        placeholder="Last Name"
                        value={formData.lastName}
                        onChange={handleNameChange}
                        onBlur={handleBlur}
                      />
                      {errors.lastName && (
                        <p className="error">{errors.lastName}</p>
                      )}
                    </Form.Group>
                  </Row>
                  <Row>
                    <Form.Group
                      className="col-md-6 mb-3"
                      controlId="exampleForm.ControlInput3"
                    >
                      <Form.Control
                        type="text"
                        name="email"
                        placeholder="Email"
                        value={formData.email}
                        onChange={handleChange}
                        onBlur={handleBlur}
                      />
                      {errors.email && <p className="error">{errors.email}</p>}
                    </Form.Group>
                    <Form.Group
                      className="col-md-6 mb-3"
                      controlId="exampleForm.ControlInput4"
                    >
                      <div style={{ display: "flex" }}>
                        <CountryCodeField
                          countryCode={formData.countryCode}
                          onManualSelect={handleCountryCodeSelect}
                          onBlur={handleBlur}
                          permissionGranted={permissionGranted}
                        />
                        <Form.Control
                          type="text"
                          name="mobile"
                          placeholder="Mobile Number"
                          value={formData.mobile}
                          onChange={handleMobileChange}
                          onBlur={handleBlur}
                        />
                      </div>

                      <div style={{ display: "flex" }}>
                        {errors.countryCode && (
                          <p className="error">{errors.countryCode}</p>
                        )}
                        {errors.mobile && (
                          <p className="error">{errors.mobile}</p>
                        )}
                      </div>
                    </Form.Group>
                  </Row>
                  <Row>
                    <Col md={12}>
                      <Form.Group>
                        <Form.Select
                          className="mb-3 form-control"
                          name="position"
                          value={formData.position}
                          onChange={handlePositionChange}
                          onBlur={handleBlur}
                        >
                          <option value="">Choose Position</option>
                          <option value={title}>{title}</option>
                        </Form.Select>
                        {errors.position && (
                          <p className="error">{errors.position}</p>
                        )}
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row>
                    <Form.Group
                      className="col-md-12 mb-3"
                      controlId="exampleForm.ControlTextarea1"
                    >
                      <Form.Control
                        as="textarea"
                        placeholder="Drop Your Message"
                        name="message"
                        value={formData.message}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        rows={3}
                      />
                      {errors.message && (
                        <p className="error">{errors.message}</p>
                      )}
                    </Form.Group>
                  </Row>
                  <Row>
                    <Form.Group htmlFor="cvInput" className="col-md-12 mb-3">
                      <Form.Control
                        type="file"
                        name="cv"
                        className="choosefile"
                        onChange={handleFileChange}
                        id="cvInput"
                        onBlur={(e) => validateField("cv", e.target.files[0])}
                        accept=".pdf,application/pdf"
                      />
                      {errors.cv && <p className="error">{errors.cv}</p>}
                    </Form.Group>
                  </Row>
                  <Row>
                    <Form.Group className="col-md-12 mb-3">
                      <ReCAPTCHA
                        className="gcaptcha-size"
                        sitekey="6LeGM28qAAAAAGmZjltF8c4tuHV9F9vxFdjtKPoC"
                        ref={captchaRef}
                        onChange={(value) => {
                          setFormData((prevData) => ({
                            ...prevData,
                            careerscaptchaToken: value,
                          }));
                          validateField("careerscaptchaToken", value);
                        }}
                      />
                      {errors.careerscaptchaToken && (
                        <p className="error gcaptcha-error-msg">
                          {errors.careerscaptchaToken}
                        </p>
                      )}
                    </Form.Group>
                  </Row>

                  <Row className="mt-2 form-btn">
                    <Col md={12}>
                      <button type="submit" className="marquis-grey-button">
                        Submit
                      </button>
                    </Col>
                  </Row>
                </Form>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Modal Component */}
      <Modal
        show={showModal}
        onHide={handleCloseModal}
        className="response-popup"
      >
        <Modal.Header>
          <Modal.Title>Thank You!</Modal.Title>
        </Modal.Header>
        <Modal.Body>Form Submitted Successfully!</Modal.Body>
        <Modal.Footer>
          <button className="marquis-grey-button" onClick={handleCloseModal}>
            Close
          </button>
        </Modal.Footer>
      </Modal>
    </Fragment>
  );
};

export default CareerInnerDescription;
